import { render, staticRenderFns } from "./InputSubPage.vue?vue&type=template&id=1a84fa9f&"
import script from "./InputSubPage.vue?vue&type=script&lang=js&"
export * from "./InputSubPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports